module.exports = __webpack_public_path__ + "static/media/1009976.4f6ef0fe.jpg";